import React from 'react';
import { Text, useToast } from '@chakra-ui/react';
import { useGetInspectionScoringSuspense, useGetScoringValidationStatusSuspense, } from '../../../services/api/generated/client';
import { unwrapModel } from '../../../services/api/unwrapModel';
import Scoring from '../Scoring';
import { useInspectionDetailContext } from '../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
import { localise } from '../../../services/lang/lang';
const ScoringContent = ({ inspection, onHazardsTableMutated, handleCloseDrawer, }) => {
    const toast = useToast();
    const { data: scoringResponse, refetch } = useGetInspectionScoringSuspense(inspection.id);
    const { data: scoringValidationResponse } = useGetScoringValidationStatusSuspense(inspection.id);
    const { canEditInspection } = useInspectionDetailContext();
    const scoringData = unwrapModel(scoringResponse);
    const scoringValidationData = unwrapModel(scoringValidationResponse);
    if (!scoringData)
        return null;
    if (!scoringValidationData) {
        return (React.createElement(Text, { "data-testid": "invalid_for_scoring_text" }, localise('INSPECTION_INVALID_FOR_SCORING')));
    }
    return (React.createElement(Scoring, { inspection: inspection, HHSRSScoring: scoringData, viewOnly: !canEditInspection, isInspectionValidForHHSRSScoring: !!scoringValidationData, isInspectionCreator: canEditInspection, isNewDesign: true, hasStartedHHSRSScoring: true, jumpToHazardsLocation: undefined, getHHSRSScoring: () => {
            refetch();
            onHazardsTableMutated?.();
        }, onSuccess: () => {
            toast({
                title: localise('SCORING_UPDATED'),
                status: 'success',
                isClosable: true,
            });
        }, handleCloseDrawer: handleCloseDrawer }));
};
export default ScoringContent;
